import React, { useState, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../context/AppContext";
import Footer from "./Layout/Footer";
import "./Layout/Layout.css"; // Ensure you have necessary styles

function MechanicDetailed() {
    const { id } = useParams();
    const [mechanic, setMechanic] = useState(null);
    const [reviews, setReviews] = useState([]);
    const [rating, setRating] = useState(0);
    const [reviewText, setReviewText] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [averageRating, setAverageRating] = useState(0);
    const [totalReviews, setTotalReviews] = useState(0);
    const { user } = useContext(AppContext); // Assuming user context exists

    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`https://dashboard.maineautoparts.com/api/mechanic/${id}/reviews`);
            if (response.data) {
                setMechanic(response.data.mechanic);
                setReviews(response.data.reviews.data);
                if (response.data.mechanic) {
                    setAverageRating(response.data.mechanic.average_rating);
                    setTotalReviews(response.data.mechanic.total_reviews);
                }
            }
        } catch (error) {
            console.error("Error fetching mechanic details:", error);
        } finally {
            setLoading(false);
        }
    };

    const submitReview = async (e) => {
        e.preventDefault();
        if (rating === 0) {
            alert("Please select a rating");
            return;
        }

        // Simple check if user is logged in if context provides it, otherwise API will handle 401
        // For this example, we assume token is in localStorage
        const token = localStorage.getItem("token");
        if (!token) {
            alert("Please login to submit a review");
            return;
        }

        setSubmitting(true);
        try {
            const data = {
                mechanic_id: id,
                rating: rating,
                review: reviewText,
            };

            await axios.post("https://dashboard.maineautoparts.com/api/mechanic-review", data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            alert("Review submitted successfully");
            setReviewText("");
            setRating(0);
            fetchData(); // Refresh reviews
        } catch (error) {
            console.error("Error submitting review:", error);
            alert("Failed to submit review: " + (error.response?.data?.message || error.message));
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {
        return <div className="container" style={{ padding: '50px', textAlign: 'center' }}>Loading...</div>;
    }

    if (!mechanic) {
        return <div className="container" style={{ padding: '50px', textAlign: 'center' }}>Mechanic not found</div>;
    }

    return (
        <div>
            <div className="container main-container">
                <ul className="breadcrumb">
                    <li>
                        <Link to="/">
                            <i className="fa fa-home"></i>
                        </Link>
                    </li>
                    <li>
                        <Link to="/mechanics">Mechanics</Link>
                    </li>
                    <li>{mechanic.name}</li>
                </ul>

                <div className="row">
                    <div id="content" className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-4 text-center">
                                <img
                                    src={mechanic.avatar || "/image/mechanic.png"} // You might need to adjust how avatar URL is passed or fallback
                                    alt={mechanic.name}
                                    className="img-responsive"
                                    style={{ borderRadius: '10px', margin: '0 auto', maxHeight: '300px' }}
                                />
                            </div>
                            <div className="col-sm-8">
                                <h1>{mechanic.name}</h1>
                                <ul className="list-unstyled">
                                    <li>
                                        <strong>Specialization:</strong> {mechanic.specialization}
                                    </li>
                                    <li>
                                        <strong>Address:</strong> {mechanic.address?.address}
                                    </li>
                                    <li>
                                        <strong>Phone:</strong> {mechanic.phone_number}
                                    </li>
                                </ul>
                                <div className="rating">
                                    <span style={{ fontSize: '24px', fontWeight: 'bold' }}>{averageRating}</span>
                                    <span className="fa fa-stack">
                                        <i className="fa fa-star fa-stack-2x"></i>
                                    </span>
                                    <span>({totalReviews} reviews)</span>
                                </div>
                                <br />
                                <a href={`tel:${mechanic.phone_number || ''}`} className="btn btn-primary" style={{ backgroundColor: '#e06027', borderColor: '#e06027' }}>Call Now</a>
                            </div>
                        </div>

                        <hr />

                        <h3>Reviews</h3>
                        <div className="row">
                            <div className="col-md-6">
                                {reviews.length === 0 ? (
                                    <p>No reviews yet. Be the first!</p>
                                ) : (
                                    reviews.map((op, i) => (
                                        <div key={i} style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <strong>{op.reviewer_name}</strong>
                                                <span>{new Date(op.created_at).toLocaleDateString()}</span>
                                            </div>
                                            <div className="rating">
                                                {[...Array(5)].map((star, index) => {
                                                    return (
                                                        <span key={index} className="fa fa-stack">
                                                            <i className={`fa fa-star fa-stack-2x ${index < op.rating ? "" : "fa-star-o"}`} style={{ color: index < op.rating ? "#FFD700" : "#ccc" }}></i>
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                            <p>{op.review}</p>
                                        </div>
                                    ))
                                )}
                            </div>

                            <div className="col-md-6">
                                <div className="well">
                                    <h4>Write a Review</h4>
                                    <form onSubmit={submitReview}>
                                        <div className="form-group">
                                            <label className="control-label">Rating</label>
                                            <div className="rating">
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <span
                                                        key={star}
                                                        style={{ cursor: 'pointer', fontSize: '20px', color: star <= rating ? '#FFD700' : '#ccc' }}
                                                        onClick={() => setRating(star)}
                                                    >
                                                        ★
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label">Your Review</label>
                                            <textarea
                                                className="form-control"
                                                rows="5"
                                                value={reviewText}
                                                onChange={(e) => setReviewText(e.target.value)}
                                            ></textarea>
                                        </div>
                                        <div className="buttons clearfix">
                                            <div className="pull-right">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    disabled={submitting}
                                                >
                                                    {submitting ? "Submitting..." : "Submit Review"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default MechanicDetailed;
